module.exports = __webpack_public_path__ + "static/media/production.660945f8.jpg";